module.exports = __webpack_public_path__ + "img/12.77f41ca7.png";